import { render } from "./SendButton.vue?vue&type=template&id=74eb19ca"
import script from "./SendButton.vue?vue&type=script&lang=js"
export * from "./SendButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__